import { Dispatch, SetStateAction, useRef, useState } from "react"
import useTranslator from "@hooks/use-translator"
import { useAuth } from "@stores/auth-store"
import { DictType } from "@pma/types"
import RichEditorQuill from "../common/rich-editor-quill"
import { Delta } from "quill"
import { cn } from "@pma/utils/helpers"

interface Props {
  setMessage: Dispatch<SetStateAction<string>>
  message: string
  reply?: boolean
  focus?: boolean
  quillId: number
  className?: string
}

export const MentionUser = ({ setMessage, message, reply, focus, quillId, className }: Props) => {
  const { translate } = useTranslator()

  const { authConfig } = useAuth()

  const organizationUsers = authConfig?.organizationUsers || []

  const mentionUsers = organizationUsers
    ?.filter((user: DictType) => user?.name)
    .map((user: DictType) => {
      return {
        id: user?.id,
        value: user?.name,
        url: user?.user_picture?.url || `${process.env.PUBLIC_URL}/user-profile.svg`,
      }
    })

  const handleChange = (e: Delta) => {
    const data = JSON.stringify(e.ops)
    setMessage(data)
  }

  return (
    <div
      className={cn(
        "mx-1 mb-1 h-full min-h-[120px] w-full min-w-0 max-w-full border text-sm text-gray-600 shadow focus:ring-0 dark:text-gray-200",
        className,
      )}
    >
      <RichEditorQuill
        placeHolder={
          reply
            ? translate("Write a reply")
            : translate("Add new note") + "...\n @" + translate("to mention people")
        }
        handleChange={handleChange}
        mentionUsers={mentionUsers}
        id={quillId.toString()}
      />
    </div>
  )
}
